(()=>{
const pad=v=>String(v).padStart(2,'0');

function parseDate(v){
  const m=/^(\d{4})-(\d{2})-(\d{2})$/.exec(v);
  if(m)return new Date(+m[1],+m[2]-1,+m[3],23,59,59,999);
  return new Date(v);
}

function countdown(w){
  const t=w.dataset.target,o=w.querySelector('[data-ppc-countdown]');
  if(!t||!o)return;

  const d=parseDate(t);
  if(Number.isNaN(d.getTime()))return;

  const els={
    d:o.querySelector('[data-days]'),
    h:o.querySelector('[data-hours]'),
    m:o.querySelector('[data-minutes]'),
    s:o.querySelector('[data-seconds]')
  };

  const x=w.querySelector('[data-ppc-expired]');

  const tick=()=>{
    const n=d.getTime()-Date.now();

    if(n<=0){
      o.hidden=true;

      if(x){
        x.textContent=w.dataset.expired||'';
        x.hidden=!x.textContent;
      }

      return false;
    }

    els.d.textContent=pad(Math.floor(n/864e5));
    els.h.textContent=pad(Math.floor(n%864e5/36e5));
    els.m.textContent=pad(Math.floor(n%36e5/6e4));
    els.s.textContent=pad(Math.floor(n%6e4/1e3));

    return true;
  };

  tick();

  const id=setInterval(()=>{
    if(!tick())clearInterval(id);
  },1000);

  w._timer=id;
}

function carousel(
  root,
  itemSel,
  prevSel,
  nextSel,
  dotSel,
  autoplay,
  speed,
  startOnView=false
){
  const items=[...root.querySelectorAll(itemSel)];
  const dots=[...root.querySelectorAll(dotSel)];
  const prev=root.querySelector(prevSel);
  const next=root.querySelector(nextSel);

  if(items.length<2)return;

  let i=0;
  let timer=null;
  let entered=!startOnView;
  let visible=!startOnView;
  let touch=0;

  const stop=()=>{
    if(timer){
      clearInterval(timer);
      timer=null;
    }
  };

  const play=()=>{
    stop();

    if(
      !autoplay ||
      !entered ||
      !visible ||
      matchMedia('(prefers-reduced-motion: reduce)').matches
    )return;

    timer=setInterval(()=>show(i+1),speed);
  };

  const show=n=>{
    i=(n+items.length)%items.length;

    items.forEach((e,j)=>{
      e.classList.toggle('is-active',j===i);
      e.setAttribute('aria-hidden',j===i?'false':'true');
    });

    dots.forEach((e,j)=>{
      e.classList.toggle('is-active',j===i);
      e.setAttribute('aria-current',j===i?'true':'false');
    });
  };

  prev?.addEventListener('click',e=>{
    e.preventDefault();
    show(i-1);
    play();
  });

  next?.addEventListener('click',e=>{
    e.preventDefault();
    show(i+1);
    play();
  });

  dots.forEach((d,j)=>{
    d.addEventListener('click',()=>{
      show(j);
      play();
    });
  });

  root.addEventListener('mouseenter',stop);
  root.addEventListener('mouseleave',play);
  root.addEventListener('focusin',stop);
  root.addEventListener('focusout',play);

  root.addEventListener(
    'touchstart',
    e=>touch=e.changedTouches[0].clientX,
    {passive:true}
  );

  root.addEventListener(
    'touchend',
    e=>{
      const dx=e.changedTouches[0].clientX-touch;

      if(Math.abs(dx)>45){
        show(dx>0?i-1:i+1);
        play();
      }
    },
    {passive:true}
  );

  show(0);

  if(startOnView&&'IntersectionObserver'in window){
    const ob=new IntersectionObserver(
      es=>es.forEach(e=>{
        visible=e.isIntersecting&&e.intersectionRatio>=.2;

        if(visible&&!entered){
          entered=true;
          show(0);
        }

        visible?play():stop();
      }),
      {threshold:[0,.2,.5]}
    );

    ob.observe(root);
    root._observer=ob;
  }else{
    entered=visible=true;
    play();
  }

  root._stop=stop;
}

function notifyGuard(root){
  const phrases=[
    'notify me when available',
    'notify when available',
    'email me when available',
    'back in stock',
    'make an offer',
    'submit offer'
  ];

  const clean=()=>{
    root
      .querySelectorAll('button,a,[role="button"],form,div')
      .forEach(el=>{
        if(
          el.closest('[data-ppc-card]') ||
          el.closest('[data-ppc-qv]')
        )return;

        const tx=(el.textContent||'').trim().toLowerCase();

        if(
          tx &&
          tx.length<100 &&
          phrases.some(p=>tx.includes(p))
        ){
          const x=
            el.closest(
              'form,[data-bis-button],[data-back-in-stock],[data-notify-me],.bis-button,.back-in-stock-button,.notify-me-button'
            ) || el;

          x.style.setProperty('display','none','important');
          x.setAttribute('aria-hidden','true');
        }
      });
  };

  clean();

  const ob=new MutationObserver(clean);

  ob.observe(root,{
    childList:true,
    subtree:true
  });

  root._notify=ob;
}

function selectedOption(card){
  const sel=card.querySelector('[data-ppc-variant-select]');

  return sel
    ? sel.options[sel.selectedIndex]
    : null;
}

function updateCard(card){
  const opt=selectedOption(card);

  if(!opt)return;

  const sale=opt.dataset.sale==='true';
  const available=opt.dataset.available==='true';
  const comingSoon=card.dataset.comingSoon==='true';
  const zeroPrice=opt.dataset.zeroPrice==='true';

  const releaseDate=
    opt.dataset.releaseDate ||
    card.dataset.releaseDate ||
    'Release date TBD';

  const current=card.querySelector('[data-ppc-current]');

  if(current){
    current.textContent=
      zeroPrice
        ? releaseDate
        : (opt.dataset.price||'');
  }

  const compare=card.querySelector('[data-ppc-compare]');

  if(compare){
    compare.textContent=
      zeroPrice
        ? ''
        : (opt.dataset.compare||'');

    compare.hidden=
      zeroPrice ||
      !sale;
  }

  const price=card.querySelector('[data-ppc-price]');

  if(price){
    price.classList.toggle(
      'is-sale',
      sale&&!zeroPrice
    );

    price.classList.toggle(
      'is-release-date',
      zeroPrice
    );
  }

  card
    .querySelectorAll(
      '[data-ppc-sale-badge],[data-ppc-sale-price-badge]'
    )
    .forEach(x=>{
      x.hidden=zeroPrice||!sale;
    });

  const image=card.querySelector('[data-ppc-card-image]');

  if(image&&opt.dataset.image){
    image.src=opt.dataset.image;
    image.removeAttribute('srcset');
  }

  card
    .querySelectorAll('[data-ppc-card-link]')
    .forEach(a=>{
      a.href=
        opt.dataset.url ||
        card.dataset.productUrl;
    });

  const add=card.querySelector('[data-ppc-add]');

  if(add){
    add.hidden=
      !available ||
      comingSoon;

    add.dataset.variantId=opt.value;
  }

  const coming=card.querySelector('[data-ppc-coming]');

  if(coming){
    coming.hidden=!comingSoon;

    coming.href=
      opt.dataset.url ||
      card.dataset.productUrl;
  }

  const notify=card.querySelector('[data-ppc-notify]');

  if(notify){
    notify.hidden=
      available ||
      comingSoon;

    notify.href=
      opt.dataset.url ||
      card.dataset.productUrl;
  }

  const ribbon=card.querySelector('[data-ppc-sold-ribbon]');

  if(ribbon){
    ribbon.hidden=
      comingSoon
        ? false
        : available;
  }

  card.classList.toggle(
    'ppc-product-card--sold-out',
    !available&&!comingSoon
  );

  card.classList.toggle(
    'ppc-product-card--coming-soon',
    comingSoon
  );
}

async function addToCart(
  variantId,
  button,
  status
){
  if(!variantId)return;

  button.disabled=true;

  const old=button.textContent;

  button.textContent='Adding…';

  try{
    const r=await fetch('/cart/add.js',{
      method:'POST',
      headers:{
        'Content-Type':'application/json',
        'Accept':'application/json'
      },
      body:JSON.stringify({
        items:[
          {
            id:Number(variantId),
            quantity:1
          }
        ]
      })
    });

    if(!r.ok){
      throw new Error(
        (await r.json()).description ||
        'Could not add item'
      );
    }

    button.textContent='Added';

    if(status){
      status.textContent='Added to cart.';
    }

    document.dispatchEvent(
      new CustomEvent(
        'cart:refresh',
        {bubbles:true}
      )
    );

    setTimeout(()=>{
      button.textContent=old;
      button.disabled=false;
    },1200);

  }catch(e){

    button.textContent=old;
    button.disabled=false;

    if(status){
      status.textContent=
        e.message ||
        'Could not add item.';
    }
  }
}

function parseProduct(card){
  try{
    return JSON.parse(
      card
        .querySelector('[data-ppc-product-json]')
        .textContent
    );
  }catch(e){
    return null;
  }
}

function initCards(root,section){
  root
    .querySelectorAll('[data-ppc-card]')
    .forEach(card=>{

      if(card.dataset.ppcBound==='true'){
        return;
      }

      card.dataset.ppcBound='true';

      const sel=
        card.querySelector(
          '[data-ppc-variant-select]'
        );

      sel?.addEventListener(
        'change',
        ()=>updateCard(card)
      );

      const add=
        card.querySelector('[data-ppc-add]');

      add?.addEventListener(
        'click',
        ()=>addToCart(
          add.dataset.variantId,
          add,
          card.querySelector(
            '[data-ppc-card-status]'
          )
        )
      );

      card
        .querySelector('[data-ppc-quick]')
        ?.addEventListener(
          'click',
          ()=>openQV(section,card)
        );

      card
        .querySelectorAll('img,a')
        .forEach(x=>{
          x.setAttribute(
            'draggable',
            'false'
          );
        });

      card.addEventListener(
        'dragstart',
        e=>e.preventDefault()
      );
    });
}

function openQV(section,card){
  const modal=
    section.querySelector('[data-ppc-qv]');

  const data=
    parseProduct(card);

  if(!modal||!data)return;

  const title=
    modal.querySelector(
      '[data-ppc-qv-title]'
    );

  const image=
    modal.querySelector(
      '[data-ppc-qv-image]'
    );

  const variantWrap=
    modal.querySelector(
      '[data-ppc-qv-variant-wrap]'
    );

  const select=
    modal.querySelector(
      '[data-ppc-qv-variant]'
    );

  const price=
    modal.querySelector(
      '[data-ppc-qv-price]'
    );

  const add=
    modal.querySelector(
      '[data-ppc-qv-add]'
    );

  const link=
    modal.querySelector(
      '[data-ppc-qv-link]'
    );

  const status=
    modal.querySelector(
      '[data-ppc-qv-status]'
    );

  title.textContent=data.title;

  select.innerHTML='';

  data.variants.forEach(v=>{
    const o=
      document.createElement('option');

    o.value=v.id;
    o.textContent=v.title;
    o.dataset.variant=
      JSON.stringify(v);

    select.appendChild(o);
  });

  if(variantWrap){
    variantWrap.hidden=
      data.variants.length<=1;
  }

  const currentId=
    selectedOption(card)?.value ||
    card.dataset.selectedVariantId;

  if(currentId){
    select.value=currentId;
  }

  const render=()=>{
    const option=
      select.options[
        select.selectedIndex
      ];

    if(!option)return;

    const v=
      JSON.parse(
        option.dataset.variant
      );

    const comingSoon=
      data.comingSoon===true ||
      card.dataset.comingSoon==='true';

    const zeroPrice=
      v.zeroPrice===true;

    image.src=v.image||'';
    image.alt=data.title;

    price.classList.toggle(
      'is-sale',
      v.sale&&!zeroPrice
    );

    price.classList.toggle(
      'is-release-date',
      zeroPrice
    );

    price.innerHTML=
      zeroPrice
        ? `<strong>${
            v.releaseDate ||
            data.releaseDate ||
            'Release date TBD'
          }</strong>`
        : `${
            v.sale
              ? `<s>${v.compare}</s>`
              : ''
          }<strong>${v.price}</strong>`;

    add.dataset.variantId=v.id;

    add.disabled=
      !v.available ||
      comingSoon;

    add.textContent=
      comingSoon
        ? 'Coming soon'
        : (
            v.available
              ? 'Add to cart'
              : 'Sold out'
          );

    link.href=
      v.url ||
      data.url;
  };

  select.onchange=render;

  render();

  status.textContent='';

  add.onclick=()=>{
    addToCart(
      add.dataset.variantId,
      add,
      status
    );
  };

  modal.hidden=false;

  document.body.classList.add(
    'ppc-qv-open'
  );

  modal
    .querySelector(
      '[data-ppc-qv-close]'
    )
    ?.focus();
}

function initQV(section){
  const modal=
    section.querySelector(
      '[data-ppc-qv]'
    );

  if(
    !modal ||
    modal.dataset.bound==='true'
  )return;

  modal.dataset.bound='true';

  const close=()=>{
    modal.hidden=true;

    document.body.classList.remove(
      'ppc-qv-open'
    );
  };

  modal
    .querySelectorAll(
      '[data-ppc-qv-close]'
    )
    .forEach(x=>{
      x.addEventListener(
        'click',
        close
      );
    });

  document.addEventListener(
    'keydown',
    e=>{
      if(
        e.key==='Escape' &&
        !modal.hidden
      ){
        close();
      }
    }
  );
}

async function loadGrid(section,wrap){
  const grid=
    wrap.querySelector(
      '[data-ppc-product-grid]'
    );

  const pager=
    wrap.querySelector(
      '[data-ppc-pagination]'
    );

  const count=
    wrap.querySelector(
      '[data-ppc-loaded-count]'
    );

  const key=
    wrap.dataset.gridKey;

  if(!grid)return;

  const update=()=>{
    if(count){
      count.textContent=
        `${
          grid.querySelectorAll(
            '.ppc-product-card'
          ).length
        } products shown`;
    }
  };

  update();

  const nextLink=()=>{
    return pager?.querySelector(
      '[data-ppc-next-page]'
    );
  };

  const load=async()=>{
    const link=nextLink();

    if(!link)return;

    pager.classList.add(
      'is-loading'
    );

    try{
      const url=
        new URL(
          link.href,
          location.origin
        );

      url.searchParams.set(
        'section_id',
        section.dataset.sectionId
      );

      const html=
        await fetch(
          url.toString(),
          {
            headers:{
              'X-Requested-With':
                'XMLHttpRequest'
            }
          }
        ).then(r=>{
          if(!r.ok){
            throw new Error(
              `HTTP ${r.status}`
            );
          }

          return r.text();
        });

      const doc=
        new DOMParser()
          .parseFromString(
            html,
            'text/html'
          );

      const newWrap=
        doc.querySelector(
          `[data-ppc-products][data-grid-key="${key}"]`
        );

      const newGrid=
        newWrap?.querySelector(
          '[data-ppc-product-grid]'
        );

      const newNext=
        newWrap?.querySelector(
          '[data-ppc-next-page]'
        );

      if(newGrid){
        newGrid
          .querySelectorAll(
            '.ppc-product-card'
          )
          .forEach(card=>{
            grid.appendChild(card);
          });

        initCards(grid,section);
        update();
      }

      pager.innerHTML=
        newNext
          ? `<a href="${
              newNext.getAttribute('href')
            }" data-ppc-next-page>${
              link.textContent
            }</a>`
          : '';

      pager.classList.remove(
        'is-loading'
      );

      bind();

      if(
        section.dataset.autoLoad==='true' &&
        newNext
      ){
        load();
      }

    }catch(e){

      console.error(
        `PokePlug ${key} collection loading failed:`,
        e
      );

      pager.classList.remove(
        'is-loading'
      );
    }
  };

  const bind=()=>{
    const link=nextLink();

    if(
      link &&
      !link.dataset.bound
    ){
      link.dataset.bound='true';

      link.addEventListener(
        'click',
        e=>{
          e.preventDefault();
          load();
        }
      );
    }
  };

  bind();

  if(
    section.dataset.autoLoad==='true' &&
    nextLink()
  ){
    load();
  }
}

function initComingSoonScrollHint(section){
  const grid=
    section.querySelector(
      '[data-ppc-product-grid="coming-soon"]'
    );

  const hint=
    section.querySelector(
      '[data-ppc-coming-scroll-hint]'
    );

  if(!grid||!hint)return;

  const update=()=>{
    const mobile=
      window.matchMedia(
        '(max-width: 749px)'
      ).matches;

    const canScroll=
      grid.scrollWidth >
      grid.clientWidth+2;

    hint.classList.toggle(
      'is-visible',
      mobile&&canScroll
    );
  };

  update();

  requestAnimationFrame(update);

  window.addEventListener(
    'resize',
    update,
    {passive:true}
  );

  const ob=
    new MutationObserver(()=>{
      requestAnimationFrame(update);
    });

  ob.observe(
    grid,
    {
      childList:true,
      subtree:false
    }
  );

  section._comingHintObserver=ob;
  section._comingHintResize=update;
}

function loadAll(section){
  section
    .querySelectorAll(
      '[data-ppc-products]'
    )
    .forEach(w=>{
      loadGrid(section,w);
    });
}

function init(section){
  if(
    section.dataset.ppcInit==='true'
  )return;

  section.dataset.ppcInit='true';

  section
    .querySelectorAll(
      '[data-ppc-countdown-wrap]'
    )
    .forEach(countdown);

  const rs=
    section.querySelector(
      '[data-ppc-release-slider]'
    );

  if(rs){
    carousel(
      rs,
      '[data-ppc-release]',
      '[data-ppc-release-prev]',
      '[data-ppc-release-next]',
      '[data-ppc-release-dot]',
      section.dataset.releaseAutoplay==='true',
      Number(
        section.dataset.releaseSpeed
      )||8000,
      true
    );
  }

  section
    .querySelectorAll(
      '[data-ppc-media-slider]'
    )
    .forEach(ms=>{
      carousel(
        ms,
        '[data-ppc-media]',
        '[data-ppc-media-prev]',
        '[data-ppc-media-next]',
        '[data-ppc-media-dot]',
        section.dataset.mediaAutoplay==='true',
        Number(
          section.dataset.mediaSpeed
        )||6000,
        false
      );
    });

  initCards(section,section);
  initQV(section);
  notifyGuard(section);
  initComingSoonScrollHint(section);
  loadAll(section);
}

function all(root=document){
  root
    .querySelectorAll(
      '[data-ppc-section]'
    )
    .forEach(init);
}

document.addEventListener(
  'DOMContentLoaded',
  ()=>all()
);

document.addEventListener(
  'shopify:section:load',
  e=>all(e.target)
);

document.addEventListener(
  'shopify:section:unload',
  e=>{
    const s=
      e.target.querySelector(
        '[data-ppc-section]'
      );

    s?._notify?.disconnect();

    s
      ?.querySelectorAll(
        '[data-ppc-countdown-wrap]'
      )
      .forEach(w=>{
        if(w._timer){
          clearInterval(w._timer);
        }
      });

    s
      ?.querySelectorAll(
        '[data-ppc-release-slider],[data-ppc-media-slider]'
      )
      .forEach(c=>{
        c._stop?.();
        c._observer?.disconnect();
      });

    s?._comingHintObserver?.disconnect();

    if(s?._comingHintResize){
      window.removeEventListener(
        'resize',
        s._comingHintResize
      );
    }
  }
);
})();